import React, {useState, useEffect} from 'react'
import Cookies from 'js-cookie'
import axios from 'axios';

import { AiFillDelete } from "react-icons/ai";
import { BsPencilSquare } from "react-icons/bs";
import { RiDeleteBack2Fill } from "react-icons/ri";

import StandardForm from '../../forms/StandardForm';

import  useSettingsStore  from "../../../stores/SettingsStore";
import  useUserStore  from '../../../stores/UserStore'

function MobileTradeSettings() {
  const {settings, fetchSettings} = useSettingsStore()
  const details = useSettingsStore((state) => state.settingsInputDetails)
  const stop_settings_list = useSettingsStore((state) => state.stopSettingList)
  const input_list = useSettingsStore((state) => state.settingsList)
  const {selectSetting, selectedSetting, clearSelectedSetting, setEmptyFieldsOff, setEmptyFieldsOn} = useSettingsStore()
  const [detailsAccordion, setDetailsAccordion] = useState(false)
  const [needToFetch, setNeedToFetch] = useState(false)
  const input_list2_name = "stop_settings"
  const strat = "setting"
  const btn_list = ['create / apply','remove']
  const url = "/api/make_setting"
  useEffect(() => {
    const fetchData = async () => {
        try {
            await fetchSettings()
        } catch (error) {
            console.log("Error fetching user settings", error);
        }
    }
    fetchData();
    setNeedToFetch(false)
}, [])

  const deleteSetting = async (e, setting) => {
    e.preventDefault()
    const token = Cookies.get('token')
    var data = {}
    data['button'] = "remove"    
    data['setting_name'] = setting
    try {
        await axios({
        headers: { Authorization: token },
        method: "POST",
        url : "/api/make_setting",
        data : data
        })
        } catch (err) {
        if (err.response.status === 401){                
            useUserStore.getState().logOut()    
        }                 
    } 
    setNeedToFetch(true)
}
const removeSelectedSetting = () => {
  clearSelectedSetting()
  setEmptyFieldsOn()
  
}
const toggleDetailsAccordion = () => {
  setDetailsAccordion(prevState => !prevState);
}
  return (
    <div className='mobile_subcontainer'>
      <ul className="settings_list" id="trade_settings">
        {settings && typeof settings === "object"
        ? Object.keys(settings).map(settingKey => (
            <li key={settingKey + "li"} className='li setting_li'>
                <div key={settingKey + "div"} className="setting_container">
                    <BsPencilSquare className="inline_icon"  onClick={() => selectSetting(settingKey)}/>
                    <AiFillDelete className="inline_icon" onClick={(e) => deleteSetting(e, settingKey)} />
                    <p className='setting_name' id={settingKey} onClick={() => selectSetting(settingKey)} >{settingKey.replaceAll('_', ' ')}</p>

                </div>
            </li>
            ))
        : null}
      </ul>
      {selectedSetting && Object.keys(selectedSetting).length !== 0 ?
          <div className='clear_selected_setting_container_std' onClick={() => removeSelectedSetting()} id='trade_settings'>
              <h3>{selectedSetting && selectedSetting["setting_name"].replaceAll('_', ' ')} </h3>
              <RiDeleteBack2Fill onClick={() => removeSelectedSetting()} className='inline_icon clear_selected_setting_icon_std no_drag' />
          </div>
          : null
      }
       <StandardForm
            // emptyFields={emptyFields} 
            // setEmptyFields={wrappedSetEmptyFields} 
            input_list={input_list} 
            details='undefined'
            input_list2={stop_settings_list} 
            input_list2_name={input_list2_name} 
            button_list={btn_list} strat={strat} 
            url={url} 
            selectedSetting={selectedSetting}
        />
        <div className="settings_infos_accordion_container" id="trade_settings">
      <div className="accordion"  >
        <h3 onClick={() => toggleDetailsAccordion()}>Settings information <span>{detailsAccordion ? "-" : "+"}</span></h3>
      </div>
      <div className={detailsAccordion ? 'settings_infos_container show_infos' : "settings_infos_container"}>
            {Object.keys(details).map(function(setting) {
                switch(setting) {
                    case 'setting_name':
                        return null
                    default:
                        return <div className='setting_info_container' key={setting +"_details"}>
                   
                        <h4 className='setting'>{setting.replaceAll("_", " ")}</h4>
                        <p className='setting_info'>{details[setting]}</p>
                    </div>
                }
            })}
        </div>
      </div>
    </div>
  )
}

export default MobileTradeSettings

